const { MESSAGES_SORT_TYPE } = require('utils/constants');
const { sortByLatestMessage } = require('utils/chatSorting');

exports.sortUsers = ({ userChannels, sortFilter, debug }) => {

    userChannels = userChannels || [];

    if (sortFilter === MESSAGES_SORT_TYPE.BY_NAME) {
        return userChannels.sort(exports.sortUsersByName);
    }

    return sortByLatestMessage({
        items: userChannels,
        getLastMessage: (userChannel) => userChannel?.lastMessage,
        sortByName: exports.sortUsersByName
    });
};

exports.sortUsersByName = (user1Channel, user2Channel) => {

    if (!user1Channel.attributes && !user2Channel.attributes) {
        return 0;
    }
    else if (!user1Channel.attributes) {
        return 1;
    }
    else if (!user2Channel.attributes) {
        return -1;
    }

    const { attributes: { user: { firstName: firstName1, lastName: lastName1 } } } = user1Channel;
    const { attributes: { user: { firstName: firstName2, lastName: lastName2 } } } = user2Channel;

    return firstName1.localeCompare(firstName2) || lastName1.localeCompare(lastName2);
};
